import { Vehicle } from '@core/Entities/Vehicle/Vehicle.entity';
import { Info } from '@gds/Icons/Paths/Info';
import Tooltip from '@gds/Tooltip/Tooltip';
import { Typography } from '@gds/Typography/Typography';

import { useAdminFee } from './AdminFee.hooks';

import { AdminFeeMessages } from './AdminFee.messages';

import styles from './AdminFee.module.css';

interface AdminFeeTooltipProps {
  messages?: AdminFeeMessages;
}

interface AdminFeeProps {
  vehicle: Vehicle | null;
  source?: 'pdp' | 'checkout';
}

const AdminFeeTooltip = ({ messages }: AdminFeeTooltipProps) => (
  <Tooltip className={styles.tooltip} dialogId="admin-fee-pdp-popover" text={messages?.tooltipText}>
    <Info fontSize={24} />
  </Tooltip>
);

const AdminFee = ({ vehicle, source }: AdminFeeProps) => {
  const { fee, messages, shouldShowEcomAdminFee, shouldShowD2cAdminFee } = useAdminFee({ vehicle });

  if (!shouldShowEcomAdminFee && !shouldShowD2cAdminFee) return null;

  const renderFee = () => {
    if (source === 'pdp') {
      return (
        <div className={styles.feeText}>
          {`Plus ${fee} admin fee`}
          <AdminFeeTooltip messages={messages} />
        </div>
      );
    }
    return fee;
  };

  return (
    <span
      className={`${styles.wrapper} ${source === 'pdp' ? styles.isPdp : ''}`}
      data-test-id={shouldShowEcomAdminFee ? 'admin-fee-ecom' : 'admin-fee-d2c'}
    >
      <Typography variant="body2">{renderFee()}</Typography>
    </span>
  );
};

export { AdminFee };
